import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <table className={classes.Table}>
            <tbody>
            <tr className={classes.EmptyRow}>
                <td colSpan="6">
                    <div className={classes.Empty}>
                        <h5>
                            <FormattedMessage id="RegistryList.empty" defaultMessage="Реестров не найдено"/>
                        </h5>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/RegistryList/Empty.js